<template>
  <component :is="active" :data="data" @changeStatus="changeStatus"></component>
</template>

<script>
export default {
  name: 'security-center',
  mixins: [],
  data() {
    return {
      p: this.$route.query.p || '2',
      data: {},
      active: 'credential'
    }
  },
  components: {
    //撞库/反盗号页面
    credential: () => import('@/views/security/models/Credential.vue'),
    device: () => import('@/views/security/models/CredentialDevice.vue')
  },
  created() {
    if (this.p === '1') {
      this.active = 'device'
    } else {
      this.active = 'credential'
    }
  },
  mounted() {},
  methods: {
    changeStatus(status, data) {
      this.active = status
      this.data = data
    }
  }
}
</script>
